var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.24219V7.3125C13.75 7.85938 13.3203 8.25 12.8125 8.25H8.125V10.75H12.8125C13.3203 10.75 13.75 11.1797 13.75 11.6875V13.7969L18.0469 9.5L13.75 5.24219ZM20 9.5C20 9.96875 19.8047 10.3984 19.4922 10.7109L14.9609 15.2422C14.6094 15.5938 14.1406 15.75 13.6719 15.75C12.6562 15.75 11.875 14.9688 11.875 13.9531V12.625H8.125C7.07031 12.625 6.25 11.8047 6.25 10.75V8.25C6.25 7.23438 7.07031 6.375 8.125 6.375H11.875V5.08594C11.875 4.07031 12.6562 3.25 13.6719 3.25C14.1406 3.25 14.6094 3.44531 14.9609 3.79688L19.4922 8.32812C19.8047 8.64062 20 9.07031 20 9.5ZM6.5625 2.625H3.4375C2.53906 2.625 1.875 3.32812 1.875 4.1875V14.8125C1.875 15.7109 2.53906 16.375 3.4375 16.375H6.5625C7.07031 16.375 7.5 16.8047 7.5 17.3125C7.5 17.8594 7.07031 18.25 6.5625 18.25H3.4375C1.52344 18.25 0 16.7266 0 14.8125V4.1875C0 2.3125 1.52344 0.75 3.4375 0.75H6.5625C7.07031 0.75 7.5 1.17969 7.5 1.6875C7.5 2.23438 7.07031 2.625 6.5625 2.625Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default ForwardRef;